import React from 'react';
import styled from 'styled-components';

export type BottomPagerProps = {
  page: number;
  totalPages?: number; // optional; if undefined, only prev/next enabled state is controlled by hasPrev/hasNext
  hasPrev?: boolean;
  hasNext?: boolean;
  onPrev: () => void;
  onNext: () => void;
  loading?: boolean;
};

const PagerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 0.75rem;
  border-top: 1px dashed rgba(0,0,0,0.08);
  margin-top: 0.75rem;
`;

const Button = styled.button`
  border: 0;
  border-radius: 10px;
  padding: 0.45rem 0.75rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg,#667eea,#764ba2);
  cursor: pointer;
  &:disabled {
    opacity: .6;
    cursor: not-allowed;
  }
`;

const Label = styled.span`
  color: #666;
  font-weight: 700;
`;

const BottomPager: React.FC<BottomPagerProps> = ({ page, totalPages, hasPrev, hasNext, onPrev, onNext, loading }) => {
  const disablePrev = loading || (hasPrev != null ? !hasPrev : page <= 0);
  const disableNext = loading || (hasNext != null ? !hasNext : (totalPages != null ? page + 1 >= totalPages : false));
  return (
    <PagerRow>
      <Button onClick={onPrev} disabled={disablePrev}>Prev</Button>
      {typeof totalPages === 'number' && (
        <Label>Page {Math.max(1, page + 1)} / {Math.max(1, totalPages)}</Label>
      )}
      <Button onClick={onNext} disabled={disableNext}>Next</Button>
    </PagerRow>
  );
};

export default BottomPager;
